import { memo } from 'react';
import Slider from '../components/slider';
import Welcome from './welcome';

const DuelanaSlider = (): JSX.Element => {
  return (
    <Slider
      items={[<Welcome key={1} />, <Welcome key={2} />, <Welcome key={3} />]}
    />
  );
};

export default memo(DuelanaSlider);
